import React, { useEffect } from "react";

// Statistic tracking scripts
export const statisticTracking = () => {
    return (
        <script
            src={`//static.etracker.com/code/e.js`}
            id={"_etLoader"}
            charSet={"UTF-8"}
            data-block-cookies={"false"}
            data-respect-dnt={"true"}
            data-secure-code={process.env.REACT_APP_ETRACKER_ID}>
        </script>
    );

    // Google Tag Manager tracking example
    /*
    <script>
    {`
         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
         })(window,document,'script','dataLayer','${process.env.REACT_APP_GTAG_ID}');
    `}
    </script>
    */
};

// Personalization scripts
export const Personalization = () => {
    useEffect(() => {
        console.log("Bigfoot: Personalization component mounted. Attempting to inject Atlassian widget.");

        try {
            const script = document.createElement("script");
            script.setAttribute("data-jsd-embedded", "");
            script.setAttribute("data-mode", "inline");
            script.setAttribute("data-open", "always");
            script.setAttribute("data-position", "right");
            script.setAttribute("data-key", "6c7222f6-f440-4bad-ad9b-c94ebaa55d2e");
            script.setAttribute("data-base-url", "https://jsd-widget.atlassian.com");
            script.src = "https://jsd-widget.atlassian.com/assets/embed.js";

            // Critical: Default dynamic scripts are async=true.
            // The manual tag in index.html (which works) is blocking (async=false).
            // We must explicitly set this to false to match that behavior.
            script.async = true;

            script.onload = () => {
                console.log("Bigfoot: Atlassian widget script loaded successfully.");
                // Manually trigger initialization by dispatching DOMContentLoaded
                // This is required because the script usually listens for this event, which has already passed.
                const event = new Event("DOMContentLoaded", {
                    bubbles: true,
                    cancelable: true,
                });
                // Dispatch on document, not window
                document.dispatchEvent(event);
            };
            script.onerror = (e) => {
                console.error("Bigfoot: Failed to load Atlassian widget script.", e);
            };

            // Inject into BODY. Some widgets fail if injected into HEAD dynamically
            // because they try to append to body immediately.
            document.body.appendChild(script);

            return () => {
                console.log("Bigfoot: Personalization component unmounting. Removing script and widget artifacts.");
                try {
                    document.body.removeChild(script);
                } catch (e) {
                    // Ignore if script was already removed
                }

                // Cleanup JSM widget iframe/container
                // The widget typically creates a container with ID "jsd-widget" or class "jsd-widget-iframe"
                const widgetIframe = document.querySelector('iframe#jsd-widget');
                if (widgetIframe) {
                    try {
                        widgetIframe.remove();
                    } catch (e) {
                        console.error("Bigfoot: Failed to remove widget iframe", e);
                    }
                }

                // Also check for div with class "jsd-widget" or similar if iframe finding fails
                const widgetDiv = document.querySelector('div#jsd-widget');
                if (widgetDiv) {
                    try {
                        widgetDiv.remove();
                    } catch (e) {
                        console.error("Bigfoot: Failed to remove widget div", e);
                    }
                }
            };
        } catch (err) {
            console.error("Bigfoot: Error in Personalization effect:", err);
        }
    }, []);

    return null;
};
